/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssigneeId,
  CalendarSyncResponse,
  EnrichmentRequest1,
  MapDataFieldRefString,
  MapString,
  OptionTimeInterval,
  ProspectBookingLimitReset,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meetings-api";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns the start and end time of the current cycle of the prospect booking limit
   *
   * @name GetCurrentCycleOfProspectBookingLimitConfig
   * @request PUT:/v3/tenant/{tenantId}/prospect-booking-limit/current-cycle
   * @secure
   */
  getCurrentCycleOfProspectBookingLimitConfig = (
    tenantId: string,
    data: ProspectBookingLimitReset,
    params: RequestParams = {},
  ) =>
    this.request<
      OptionTimeInterval,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/prospect-booking-limit/current-cycle`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getCurrentCycleOfProspectBookingLimitConfig */
  getCurrentCycleOfProspectBookingLimitConfigPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/prospect-booking-limit/current-cycle`);

  /**
   * @description Synchronizes calendar events to fix any inconsistencies between meeting data and calendar events
   *
   * @name SyncCalendarEventsForAMeeting
   * @request POST:/v3/tenant/{tenantId}/meeting/{meetingId}/calendar/sync-events
   * @secure
   */
  syncCalendarEventsForAMeeting = (tenantId: string, meetingId: string, params: RequestParams = {}) =>
    this.request<
      CalendarSyncResponse,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/meeting/${meetingId}/calendar/sync-events`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for syncCalendarEventsForAMeeting */
  syncCalendarEventsForAMeetingPathGetter = (tenantId: string, meetingId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/meeting/${meetingId}/calendar/sync-events`);

  /**
   * @description Returns a list of known CRM values depending on configured mappings
   *
   * @name FindAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi
   * @request PUT:/v3/tenant/{tenantId}/enrichment/find-any-crm-values
   * @secure
   */
  findAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi = (
    tenantId: string,
    data: EnrichmentRequest1,
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataFieldRefString,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/enrichment/find-any-crm-values`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi */
  findAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApiPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/enrichment/find-any-crm-values`);

  /**
   * @description Returns a list of known CRM values depending on configured mappings
   *
   * @name FindKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi
   * @request PUT:/v3/tenant/{tenantId}/enrichment/find-enrichment-data
   * @secure
   */
  findKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi = (
    tenantId: string,
    data: EnrichmentRequest1,
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataFieldRefString,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/enrichment/find-enrichment-data`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi */
  findKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApiPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/enrichment/find-enrichment-data`);
}
